import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { QuoteRepository } from '../application/QuoteRepository'

export function createResilientQuoteRepository(
  primary: QuoteRepository,
  fallback: QuoteRepository,
): QuoteRepository {
  return {
    async list(filters) {
      try {
        return await primary.list(filters)
      } catch (error) {
        reportUnexpectedError(error, { feature: 'quotes', operation: 'list', fallback: true })
        const result = await fallback.list(filters)
        return {
          ...result,
          meta: { ...result.meta, source: 'fixture-fallback', fallbackReason: 'QUOTES_REMOTE_UNAVAILABLE' },
        }
      }
    },
    async getByReference(reference) {
      try {
        return await primary.getByReference(reference)
      } catch (error) {
        reportUnexpectedError(error, { feature: 'quotes', operation: 'detail', fallback: true })
        const result = await fallback.getByReference(reference)
        return result
          ? {
              ...result,
              meta: {
                ...result.meta,
                source: 'fixture-fallback',
                fallbackReason: 'QUOTES_REMOTE_UNAVAILABLE',
              },
            }
          : null
      }
    },
    createDraft(command) {
      return primary.createDraft(command)
    },
    replaceDraftItems(command) {
      return primary.replaceDraftItems(command)
    },
    prepareDraft(command) {
      return primary.prepareDraft(command)
    },
    sendPrepared(command) {
      return primary.sendPrepared(command)
    },
    acceptSent(command) {
      return primary.acceptSent(command)
    },
    setCompetitor(command) {
      return primary.setCompetitor(command)
    },
  }
}
